module.exports = __webpack_public_path__ + "media/images/pic/anime/superhero-2185255875f18fc1c4faeb4755a46b20.svg";